import axios from '../axios'
import collectUrls from '../urls/collect.js'

export default {
  // 获取客户端栏目和模型
  getClientData (data) {
    return axios.get(collectUrls.getClientData + `?identity=${data.id}&appId=${data.appid}`)
  },
  // 校验任务名称是否重复
  fetchNameCheck (data) {
    return axios.get(collectUrls.fetchNameCheck, data)
  },
  // 获取云端appid和模型
  fetchSetYunAppIdOrModel (data) {
    return axios.put(collectUrls.yunAppIdOrModel, data)
  },
  // 开始快速采集任务
  fetchCollectStart (data) {
    return axios.post(collectUrls.collectStart, data)
  },
  // 重新开始快速采集任务
  fetchCollectUpdate (data) {
    return axios.put(collectUrls.collectUpdate, data)
  },
  // 采集任务详情
  fetchCollectTaskDetail (id) {
    return axios.get(collectUrls.collectTask + `/${id}`)
  },
  // 暂停采集任务
  fetchCollectPause (id) {
    return axios.get(collectUrls.collectPause + `/${id}`)
  },
  // 恢复采集任务
  fetchCollectRecover (id) {
    return axios.get(collectUrls.collectRecover + `/${id}`)
  },
  // 停止采集任务
  fetchCollectStop (id) {
    return axios.get(collectUrls.collectStop + `/${id}`)
  },
  // 采集任务列表
  fetchCollectTaskList (data) {
    return axios.get(collectUrls.collectTask + `?appId=${data.id}&identity=${data.identity}`)
  },
  // 字段多选列表
  fetchFiledIdsOption (data) {
    return axios.get(collectUrls.collectFiledList, data)
  },
  // 任务新建
  fetchCollectTaskCreate (data) {
    return axios.post(collectUrls.collectTask, data)
  },
  // 任务删除
  fetchCollectTaskDelete (data) {
    return axios.delete(collectUrls.collectTask, data)
  },
  // 任务修改
  fetchCollectTaskUpdate (data) {
    return axios.put(collectUrls.collectTask, data)
  },
  // 校验名称
  fetchCollectTaskUnique (data) {
    return axios.get(collectUrls.collectTaskUnique, data)
  },
  // 采集数据列表
  fetchCollectContentList (data) {
    return axios.get(collectUrls.collectContentList, data)
  },
  // 采集模板列表
  fetchCollectTemplateList (data) {
    return axios.get(collectUrls.collectTemplateList, data)
  },
  // 采集模板详情
  fetchCollectTemplate (data) {
    return axios.get(collectUrls.collectTemplate + `/${data.id}`)
  },
  // 自定义采集 URL 分析
  fetchCollectAnalysisUrl (data) {
    return axios.post(collectUrls.collectAnalysisUrl, data)
  },
  // 自定义采集 保存
  fetchCollectCustomTaskExt (data) {
    return axios.post(collectUrls.collectCustomTaskExt, data)
  },
  // 自定义采集 立即采集
  fetchCollectCustomTaskExtStart (data) {
    return axios.post(collectUrls.collectCustomTaskExtStart, data)
  },
  // 自定义采集 修改任务
  fetchCollectCustomTaskExtPut (data) {
    return axios.put(collectUrls.collectCustomTaskExtPut, data)
  },
  // 自定义采集 修改任务立即采集
  fetchCollectCustomTaskExtStartPut (data) {
    return axios.put(collectUrls.collectCustomTaskExtStartPut, data)
  },
  // 自定义采集 任务详情
  fetchCollectTaskExtDetail (id) {
    return axios.get(collectUrls.collectCustomTaskExt + `/${id}`)
  },
  // 自定义采集 选择字段 获取采集结果
  fetchCollectCustomTaskListElement (data) {
    return axios.post(collectUrls.collectCustomTaskListElement, data)
  },
  // 自定义采集 深入采集元素分析
  fetchCollectCustomTaskElement (data) {
    return axios.post(collectUrls.collectCustomTaskListElement, data)
  },
  // 自定义采集 获取深入采集数据
  fetchCollectCustomTaskElementForDeep (data) {
    return axios.post(collectUrls.collectCustomTaskElementForDeep, data)
  },
  // 自定义采集 根据字段获取深入采集数据
  fetchCollectCustomTaskElementForBatch (data) {
    return axios.post(collectUrls.collectCustomTaskElementForBatch, data)
  }
}
